export default __webpack_public_path__ + "static/media/head02_vi_pc.a0193b0c.png";